import Vue from 'vue'
import Router from 'vue-router'
//import Home from './views/Home.vue'
//import Giftcards from './views/Giftcards.vue'
//import Reviews from './views/Reviews.vue'
//import Shop from './views/Shop.vue'
//import Book from './views/Book.vue'
//import User from './views/User.vue'
//import Contact from './views/Contact.vue'

Vue.use(Router);

var router = new Router({
    mode: "abstract",
    routes: [
        {
            path: '/',
            name: 'home',
            redirect: "/contact"
        },
        {
            path: '/contact',
            name: 'contact',
            component: function () {
                //return import(/* webpackChunkName: "contact" */ './views/Contact.vue')
                return import(/* webpackChunkName: "contact" */ './views/Contact2.vue')
            },
            beforeRouteEnter(to, from, next) {
                this.$store.dispatch("removeTemporaryData",{name:"book_selected_services"});
            }
        },
        {
            path: '/checkout',
            name: 'checkout',
            component: function () {
                return import(/* webpackChunkName: "checkout" */ './views/Checkout.vue')
            },
            beforeRouteEnter(to, from, next) {
                this.$store.dispatch("removeTemporaryData",{name:"book_selected_services"});
            }
        },
        {
            path: '/giftcards',
            name: 'giftcards',
            //component: Giftcards
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            // component: function () {
            // return import(/* webpackChunkName: "giftcards" */ './views/Giftcards.vue')
            // }
            component: function () {
                //return import(/* webpackChunkName: "giftcards" */ './views/Giftcards.vue')
                return import(/* webpackChunkName: "giftcards" */ './views/Giftcards2.vue')
            },
            beforeRouteEnter(to, from, next) {
                this.$store.dispatch("removeTemporaryData",{name:"book_selected_services"});
            }
        },
        {
            path: '/subscriptions',
            name: 'subscriptions',
            //component: Giftcards
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            // component: function () {
            // return import(/* webpackChunkName: "giftcards" */ './views/Giftcards.vue')
            // }
            component: function () {
                //return import(/* webpackChunkName: "giftcards" */ './views/Giftcards.vue')
                return import(/* webpackChunkName: "subscriptions" */ './views/Subscriptions.vue')
            },
            beforeRouteEnter(to, from, next) {
                this.$store.dispatch("removeTemporaryData",{name:"book_selected_services"});
            }
        },
        {
            path: '/courses',
            name: 'courses',
            component: function () {
                return import(/* webpackChunkName: "courses" */ './views/Courses.vue')
            },
            beforeRouteEnter(to, from, next) {
                this.$store.dispatch("removeTemporaryData",{name:"book_selected_services"});
            }
        },
        {
            path: '/reviews',
            name: 'reviews',
            component: function () {
                return import(/* webpackChunkName: "reviews" */ './views/Reviews.vue')
            },
            beforeRouteEnter(to, from, next) {
                this.$store.dispatch("removeTemporaryData",{name:"book_selected_services"});
            }
        },
        {
            path: '/shop',
            name: 'shop',
            component: function () {
                //return import(/* webpackChunkName: "shop" */ './views/Shop.vue')
                return import(/* webpackChunkName: "shop" */ './views/Shop2.vue')
            },
            beforeRouteEnter(to, from, next) {
                this.$store.dispatch("removeTemporaryData",{name:"book_selected_services"});
            }
        },
        {
            path: '/book',
            name: 'book',
            //component: Book
            component: function () {
                //return import(/* webpackChunkName: "book" */ './views/Book3.vue')
                return import(/* webpackChunkName: "book" */ './views/Book4.vue')
            }           
        },
        {
            path: '/user',
            name: 'user',
            component: function () {
                //return import(/* webpackChunkName: "user" */ './views/User.vue')
                return import(/* webpackChunkName: "user" */ './views/User2.vue')
            }
        }
    ],
    default: "shop"
})

router.beforeEach((to, from, next) => {
    if(from.name == "book" && BookingPortal.$store.state.settings.forcedTeammember != "") {
        BookingPortal.$store.commit("set_services",[]);
        BookingPortal.$store.commit("set_teammembers",{CategoryId:"",TeamMembers:[]});
        BookingPortal.$store.commit("set_forcedteammember","");
    }
    next();
});

router.replace("shop");

export default router;
